export class PaymentMethod {
  constructor(
    public hash?: string,
    public name?: string,
    public description?: string
  ) { }

  clone() {
    return new PaymentMethod(
      this.hash,
      this.name,
      this.description
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/payment-method.ts